"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultilingualCurrentLanguageSymbol = void 0;
exports.MultilingualCurrentLanguageSymbol = Symbol('currentLanguage');
//# sourceMappingURL=currentLanguage.js.map